<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-tabs
          v-model="activeName"
          type="card"
          style="height: 100%"
          @tab-click="getInfo"
        >
          <el-tab-pane label="电消耗" name="Electricity">
            <el-row style="height: 40px">
              <el-date-picker
                v-model="DataInfo[activeName].YearMonth"
                type="monthrange"
                align="right"
                format="yyyyMM"
                value-format="yyyyMM"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
              <el-button
                type="primary"
                @click="getInfo"
                style="margin-left: 10px"
                >查询</el-button
              >
            </el-row>
            <el-table
              :data="DataInfo['Electricity'].tableData"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 40px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>
              <el-table-column
                label="年月"
                align="center"
                prop="iYearMonth"
                sortable
                width="120"
              >
              </el-table-column>
              <el-table-column
                label="设备编号"
                align="center"
                prop="DeviceCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="设备名称"
                align="center"
                prop="DeviceName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="电消耗"
                align="center"
                prop="ElectricityConsumptionQty"
                sortable
              >
                <template slot-scope="scope">
                  <span
                    v-for="(item, index) in Object.keys(
                      JSON.parse(scope.row.ElectricityConsumptionQty)
                    )"
                    :key="item + index"
                  >
                    {{ item
                    }}{{
                      Object.values(
                        JSON.parse(scope.row.ElectricityConsumptionQty)
                      )[index]
                    }}
                    <span
                      v-if="
                        index !==
                        Object.keys(
                          JSON.parse(scope.row.ElectricityConsumptionQty)
                        ).length -
                          1
                      "
                      >/</span
                    >
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="平均价"
                align="right"
                prop="AvgPrice"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                align="right"
                prop="Amount"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.Amount, 2) }}
                </template>
              </el-table-column>
              <el-table-column label="总数量" align="right" prop="Qty" sortable>
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.Qty, 2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="水消耗" name="Water">
            <el-row style="height: 40px">
              <el-date-picker
                v-model="DataInfo[activeName].YearMonth"
                type="monthrange"
                align="right"
                format="yyyyMM"
                value-format="yyyyMM"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
              <el-button
                type="primary"
                @click="getInfo"
                style="margin-left: 10px"
                >查询</el-button
              >
            </el-row>
            <el-table
              :data="DataInfo['Water'].tableData"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 40px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>

              <el-table-column
                label="年月"
                align="center"
                prop="iYearMonth"
                sortable
                width="120"
              >
              </el-table-column>
              <el-table-column
                label="设备编号"
                align="center"
                prop="DeviceCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="设备名称"
                align="center"
                prop="DeviceName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="水消耗"
                align="center"
                prop="WaterConsumptionQty"
                sortable
              >
                <template slot-scope="scope">
                  {{
                    scope.row.WaterConsumptionQty
                      ? JSON.parse(scope.row.WaterConsumptionQty)
                      : ''
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="平均价"
                align="right"
                prop="AvgPrice"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                align="right"
                prop="Amount"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.Amount, 2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="气消耗" name="Gas">
            <el-row style="height: 40px">
              <el-date-picker
                v-model="DataInfo[activeName].YearMonth"
                type="monthrange"
                align="right"
                format="yyyyMM"
                value-format="yyyyMM"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
              <el-button
                type="primary"
                @click="getInfo"
                style="margin-left: 10px"
                >查询</el-button
              >
            </el-row>
            <el-table
              :data="DataInfo['Gas'].tableData"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 40px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>

              <el-table-column
                label="年月"
                align="center"
                prop="iYearMonth"
                sortable
                width="120"
              >
              </el-table-column>
              <el-table-column
                label="设备编号"
                align="center"
                prop="DeviceCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="设备名称"
                align="center"
                prop="DeviceName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="气消耗"
                align="center"
                prop="GasConsumptionQty"
                sortable
              >
                <template slot-scope="scope">
                  {{
                    scope.row.GasConsumptionQty
                      ? JSON.parse(scope.row.GasConsumptionQty)
                      : ''
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="平均价"
                align="right"
                prop="AvgPrice"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                align="right"
                prop="Amount"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.Amount, 2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="油消耗" name="Oil">
            <el-row style="height: 40px">
              <!--              <el-date-picker-->
              <!--                  v-model="DataInfo[activeName].YearMonth"-->
              <!--                  format="yyyyMM"-->
              <!--                  value-format="yyyyMM"-->
              <!--                  type="month"-->
              <!--                  style="width: 300px; margin-left: 10px"-->
              <!--                  placeholder="请选择月份"-->
              <!--              >-->
              <!--              </el-date-picker>-->
              <el-date-picker
                v-model="DataInfo[activeName].YearMonth"
                type="monthrange"
                align="right"
                format="yyyyMM"
                value-format="yyyyMM"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
              <el-button
                type="primary"
                @click="getInfo"
                style="margin-left: 10px"
                >查询</el-button
              >
            </el-row>
            <el-table
              :data="DataInfo['Oil'].tableData"
              ref="dialogTable"
              style="width: 100%"
              height="calc(100% - 40px)"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>

              <el-table-column
                label="年月"
                align="center"
                prop="iYearMonth"
                sortable
                width="120"
              >
              </el-table-column>
              <el-table-column
                label="设备编号"
                align="center"
                prop="DeviceCode"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="设备名称"
                align="center"
                prop="DeviceName"
                sortable
              >
              </el-table-column>
              <el-table-column
                label="气消耗"
                align="center"
                prop="GasConsumptionQty"
                sortable
              >
                <template slot-scope="scope">
                  {{
                    scope.row.OilConsumptionQty
                      ? JSON.parse(scope.row.OilConsumptionQty)
                      : ''
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="平均价"
                align="right"
                prop="AvgPrice"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                align="right"
                prop="Amount"
                sortable
              >
                <template slot-scope="scope">
                  {{ tools.momenyFormat(scope.row.Amount, 2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      tools,
      title: '',
      loading: false,
      activeName: 'Electricity',
      RoleList: [],
      tableData: [],
      DataInfo: {
        Electricity: {
          YearMonth: '',
          tableData: [],
        },
        Gas: {
          YearMonth: '',
          tableData: [],
        },
        Water: {
          YearMonth: '',
          tableData: [],
        },
        Oil: {
          YearMonth: '',
          tableData: [],
        },
      },
      drawer: false,
      disabled: false,
      row: {},
    }
  },
  props: {},
  components: {},
  methods: {
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      this.row = row

      this.DataInfo = {
        Electricity: {
          YearMonth: '',
          tableData: [],
        },
        Gas: {
          YearMonth: '',
          tableData: [],
        },
        Water: {
          YearMonth: '',
          tableData: [],
        },
        Oil: {
          YearMonth: '',
          tableData: [],
        },
      }

      this.title = title

      this.getInfo()
    },
    getInfo() {
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetConsumptionList', {
          DeviceItemId: this.row.Id,
          Type: this.activeName,
          YearMonth:
            this.DataInfo[this.activeName].YearMonth?.length > 0
              ? this.DataInfo[this.activeName].YearMonth.join(',')
              : '',
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.DataInfo[this.activeName].tableData = resJson.Data?.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
